import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { ConfiguracionTiposVariablesIncentivosService } from '../../services/configuracion-tipos-variables-incentivos.service';
import { AsignacionesService } from '../../services/asignaciones.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-asignaciones',
  templateUrl: './asignaciones.component.html',
  styleUrls: ['./asignaciones.component.css']
})
export class AsignacionesComponent implements OnInit {

  tituloCard: string = 'Asignación y Distribución de Pesos a Variables Fijas y Canales';
  tituloForm: string = 'Lista De Asignación y Distribución de Pesos a Variables Fijas y Canales';

  formulario: FormGroup;
  formularioDetalle: FormGroup;
  formularioCategorias: FormGroup;
  formularioFiltroTipoDeVendedores: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;
  isCreate: boolean;
  isCreateSubDistribucion: boolean;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstadosFiltro: any[] = [
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _serviciosCRUD: AsignacionesService,
    private _tipoDeVendedor: TipoDeVendedorService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _tipoDeVariables: ConfiguracionTiposVariablesIncentivosService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idAsignacion: ['', null],
      fechaInicio: ['', []],
      fechaFin: ['', []],
      tipoVendedorId: ['', []],
      tipoAsignacion: ['', []],
      vendedorId: ['', []],
      usuarioCarga: ['', [Validators.required]],
      fechaCarga: ['', []],
      fechaCargaDDMMYYYY: ['', [Validators.required]],
      estado: ['', [Validators.required]],
      tipoVendedorDescripcion: ['', []],
      nombreVendedorDescripcion: ['', []],
      sueldoVariable: ['', []],
      fechaInicioDDMMYYYY: ['', [Validators.required]],
      fechaFinDDMMYYYY: ['', []],
    });

    this.formularioDetalle = this.fb.group({
      asignacionId: ['', []],
      variableId: ['', [Validators.required]],
      valorPeso: ['', [Validators.required, Validators.max(100), Validators.min(0)]],
      subcategoria: ['', []],
      cumplimiento: ['', []],
      ganancia: ['', []],
      tipoVendedorDescripcion: ['', []],
      variableDescripcion: ['', []],
      dolares: ['', []],
    });

    this.formularioFiltroTipoDeVendedores = this.fb.group({
      idTipoVendedor: ['', []],
    });

    this.formularioCategorias = this.fb.group({
      macroCategoria: ['', [Validators.required]],
      linea: ['', [Validators.required]],
      categoria: ['', [Validators.required]],
      subCategoria: ['', [Validators.required]],
      valorPeso: [1],
    });

    this.cargarGridcomponent();
    this.getTodo();

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.formulario.get('sueldoVariable').setValue('');
          this.loading = true;
          this._tipoDeVendedor.getTipoDeVendedoreByID(resp).subscribe((res: any) => {
            // console.log("getPorVendedorId()", res)
            if (res) {
              // console.log("PASO1", res)
              this.formulario.get('sueldoVariable').setValue(res.sueldoVariable);
            } else {
              // console.log("NO PASO")
              this.formulario.get('sueldoVariable').setValue('');
            }
          }, (err) => {
            this.loading = false;
            this.formulario.get('sueldoVariable').setValue('');
          });
        }
        this.getFormValidationErrors();
      });

    this.formularioDetalle.get('variableId').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.loading = true;
          let index = this.listTiposDeVariables.findIndex(e => e.idVariable == resp);
          this.variableSeleccionada = this.listTiposDeVariables[index];
        }
        this.listSubDistribucion = [];
        this.totalPorcentaje = 0;
        this.getFormValidationErrors();
      });

    this.formularioCategorias.get('macroCategoria').valueChanges
      .subscribe((resp) => {
        this.listLineas = [];
        this.listCategroias = [];
        this.listSubCategorias = [];
        if (resp) {
          this.getLineas(resp);
        }
        this.getFormValidationErrors();
      });

    this.formularioCategorias.get('linea').valueChanges
      .subscribe((resp) => {
        this.listCategroias = [];
        this.listSubCategorias = [];
        if (resp) {
          this.getCategroias(resp);
        }
        this.getFormValidationErrors();
      });

    this.formularioCategorias.get('categoria').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.listSubCategorias = [];
          this.getSubCategroias(resp);
        }
        this.getFormValidationErrors();
      });

    this.formularioCategorias.get('valorPeso').valueChanges
      .subscribe((resp) => {
        this.totalPorcentajeSubCategorias();
        if ((parseFloat(this.totalPorcentaje) + parseFloat(this.formularioCategorias.get('valorPeso').value)) > 100) {
          this._utils.mensajeErroToast('El total de Peso Asignado no puede ser mayor a 100.');
        }
        this.getFormValidationErrors();
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.getVendedores(resp)
        }
        else {
          this.listVendedores = [];
          this.listVendedores.unshift({
            nombreVendedor1: 'TODOS',
            idVendedor: '',
          });
        }
        this.getFormValidationErrors();
      });

    this.formularioFiltroTipoDeVendedores.get('idTipoVendedor').valueChanges
      .subscribe((resp) => {
        this.getTiposDeVendedoresGrid(resp)
      });

    this.getTiposDeVendedores();
    this.getTiposDeVariables();
    this.getMacroCategorias();

  }


  variableSeleccionada = {
    tipoVariable: ""
  };

  listVendedores;
  getVendedores(tipoDeVendeddor) {
    this.loading = true;
    this._altaDeVendedor.getTodoPorTipo(tipoDeVendeddor).subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listVendedores = res;

      this.listVendedores.unshift({
        nombreVendedor1: 'TODOS',
        idVendedor: '',
      });

      if (this.datosCabecera)
        this.formulario.get("vendedorId").setValue(this.datosCabecera.vendedorId);
      else
        this.formulario.get("vendedorId").setValue('');

    }, (err) => {
      this.loading = false;
      this.listVendedores = [];
    });
  }

  listTiposDeVendedores;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      // console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;

      this.listTiposDeVendedores.unshift({
        descripcion: 'TODOS',
        idTipo: '',
      });

      this.formularioFiltroTipoDeVendedores.get("idTipoVendedor").setValue('');

    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  getTiposDeVendedoresGrid(id) {
    this.loading = true;
    this._serviciosCRUD.getTiposDeVendedoresGrid(id).subscribe((res: any[]) => {
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  listMacroCategorias;
  getMacroCategorias() {
    this.loading = true;
    this._serviciosCRUD.getMacroCategoria().subscribe((res: any[]) => {
      // console.log("getMacroCategorias()", res)
      this.loading = false;
      this.listMacroCategorias = res;
    }, (err) => {
      this.loading = false;
      this.listMacroCategorias = [];
    });
  }

  listLineas;
  getLineas(macroCategoria) {
    this.loading = true;
    this._serviciosCRUD.getLineas(macroCategoria).subscribe((res: any[]) => {
      // console.log("getLineas()", res)
      this.loading = false;
      this.listLineas = res;
    }, (err) => {
      this.loading = false;
      this.listLineas = [];
    });
  }

  listCategroias;
  getCategroias(linea) {
    this.loading = true;
    this._serviciosCRUD.getCategorias(linea).subscribe((res: any[]) => {
      // console.log("getCategroias()", res)
      this.loading = false;
      this.listCategroias = res;
    }, (err) => {
      this.loading = false;
      this.listCategroias = [];
    });
  }

  listSubDistribucion = [];

  listSubCategorias;
  getSubCategroias(categoria) {
    this.loading = true;
    this._serviciosCRUD.getSubCategorias(categoria).subscribe((res: any[]) => {
      // console.log("getSubCategroias()", res)
      this.loading = false;
      this.listSubCategorias = res;
    }, (err) => {
      this.loading = false;
      this.listSubCategorias = [];
    });
  }

  listTiposDeVariables;
  getTiposDeVariables() {
    this.loading = true;
    this._tipoDeVariables.getTodoPorEstado("1").subscribe((res: any[]) => {
      // console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listTiposDeVariables = res.filter(v => v.tipoVariable != "INCENTIVO");

      for (let i = 0; i < this.listTiposDeVariables.length; i++) {
        this.listTiposDeVariables[i].descripcion = this.listTiposDeVariables[i].idVariable + " - " + this.listTiposDeVariables[i].descripcion;

      }
    }, (err) => {
      this.loading = false;
      this.listTiposDeVariables = [];
    });
  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idAsignacion',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'descripcionVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Peso',
        field: 'peso',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado',
        field: 'estado',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Inicio',
        field: 'fechaInicio',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Fin',
        field: 'fechaFin',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  nuevo() {
    this.datosCabecera = {};
    this.totalPesos = 0;
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = (today.getMonth() + 1); // Months start at 0!
    let dd = today.getDate();
    let ddd, mmm;

    if (dd < 10) { ddd = '0' + dd; } else { ddd = dd; }
    if (mm < 10) { mmm = '0' + mm; } else { mmm = mm; }

    const formattedToday = ddd + '/' + mmm + '/' + yyyy;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    // console.log("formattedToday", formattedToday)
    console.log("userData", userData)
    this.listDetalles = [];
    this.isCreate = true;
    this.formulario.reset();
    this.formularioCategorias.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.formulario.get('estado').setValue('DESBALANCE');
    this.formulario.get('usuarioCarga').setValue(userData.login2);
    this.formulario.get('fechaCargaDDMMYYYY').setValue(formattedToday);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Configuración';
  }

  datosCabecera: any = {};
  listDetalles = [];
  editar({ rowData }) {
    this.loading = true;
    this.formulario.reset();
    this.formularioCategorias.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.listDetalles = [];
    this.isCreate = false;
    // console.log("editar", rowData)
    this._serviciosCRUD.getPorId(rowData.idAsignacion).subscribe((res: any) => {
      console.log("getPorId()", res)
      this.datosCabecera = res;
      res.fechaInicioDDMMYYYY = res.fechaInicio.split('T')[0];
      res.fechaFinDDMMYYYY = res.fechaFin ? res.fechaFin.split('T')[0] : '';
      res.fechaCargaDDMMYYYY = res.fechaCarga.split('T')[0].split('-').reverse().join('/');
      this.formulario.setValue(res);
      if (res.vendedorId === null) {
        setTimeout(() => {
          this.formulario.get("vendedorId").setValue("");
        }, 1500);
      }
      this._serviciosCRUD.getPorIdDetalle(rowData.idAsignacion).subscribe((res: any) => {
        // console.log("CABECERA", res)
        // console.log("DETALLE", res.lsDetalle)
        // console.log("listTiposDeVariables", this.listTiposDeVariables)

        for (let i = 0; i < res.lsDetalle.length; i++) {
          let data = res.lsDetalle[i];
          let variableDescripcion = this.listTiposDeVariables.findIndex(e => e.idVariable == res.lsDetalle[i].variableId);
          // let tipoVendedorDescripcion = this.listTiposDeVendedores.findIndex(e => e.idTipo == res.lsDetalle[i].variableId);
          // console.log("variableDescripcion", variableDescripcion)
          data.dolares = (parseFloat(this.formulario.get("sueldoVariable").value) * (res.lsDetalle[i].valorPeso / 100)).toFixed(2);
          data.variableDescripcion = this.listTiposDeVariables[variableDescripcion].descripcion;
          data.variableDistribuida = this.listTiposDeVariables[variableDescripcion].tipoVariable == "DISTRIBUIDA" ? true : false;
          // data.tipoVendedorDescripcion = this.listTiposDeVendedores[tipoVendedorDescripcion].descripcion;

          if (data.variableDistribuida) {
            this._serviciosCRUD.getSubDistribuciones(rowData.idAsignacion, data.variableId).subscribe((res: any[]) => {
              data.subcategorias = res;
              this.listDetalles.push(data);
              this.totalPesosDolares();
            }, (err) => {
              data.subcategorias = null;
              this.listDetalles.push(data);
              this.totalPesosDolares();
            });
          }
          else {
            data.subcategorias = null;
            this.listDetalles.push(data);
            this.totalPesosDolares();
          }
        }

        this.loading = false;
        console.log("this.listDetalles", this.listDetalles)
      }, (err) => {
        this.loading = false;
      });
    }, (err) => {
      this.loading = false;
      this.formulario.reset();
    });


  }

  acciones(event) {
    // debugger
    // console.log("acciones", event);
    if (event === 'guardar') {
      if (this.isCreate) this.guardar();
      else this.actualizar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Asignación y Distribución de Pesos a Variables Fijas y Canales';
    this.tituloForm = 'Lista De Asignación y Distribución de Pesos a Variables Fijas y Canales';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      // console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    // console.log("eliminar", rowData)
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(rowData.idAsignacion),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    this.listSubDistribucion = [];
    let datos = this.formulario.getRawValue();

    if (this.isCreate) {
      datos.fechaInicio = datos.fechaInicioDDMMYYYY + "T00:00:00";
      datos.fechaFin = datos.fechaFinDDMMYYYY ? datos.fechaFinDDMMYYYY + "T00:00:00" : null;
      datos.fechaCarga = datos.fechaCargaDDMMYYYY.split('/').reverse().join('-') + "T00:00:00";
    } else {
      datos.fechaInicio = datos.fechaInicioDDMMYYYY + "T00:00:00";
      datos.fechaFin = datos.fechaFinDDMMYYYY ? datos.fechaFinDDMMYYYY + "T00:00:00" : null;
      datos.fechaCarga = datos.fechaCargaDDMMYYYY.split('/').reverse().join('-') + "T00:00:00";
    }

    // console.log("guardar()", datos);
    // console.log("listDetalles", this.listDetalles)
    // console.log("listSubDistribucion", this.listSubDistribucion)

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: this.formulario.get('estado').value == "DESBALANCE" ? 'Asignación desbalanceada, está seguro de continuar?' : '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {

      console.log("ASIGNACION CREADA", res)

      setTimeout(() => {
        for (let i = 0; i < this.listDetalles.length; i++) {
          this.listSubDistribucion = [];
          this.listDetalles[i].asignacionId = res.idAsignacion;
          for (let j = 0; j < this.listDetalles[i].subcategorias.length; j++) {
            this.listSubDistribucion.push(this.listDetalles[i].subcategorias[j]);
          }

          for (let i = 0; i < this.listSubDistribucion.length; i++) this.listSubDistribucion[i].asignacionId = res.idAsignacion;

          this._serviciosCRUD.saveSubCategorias(this.listSubDistribucion).subscribe((res: any[]) => {
            this.loading = false;
            this.listSubDistribucion = [];
          }, (err) => {
            this.loading = false;
            this.listSubDistribucion = [];
          });

        }

        console.log("guardar()", datos);
        console.log("listDetalles", this.listDetalles)
        console.log("listSubDistribucion", this.listSubDistribucion)

        this._serviciosCRUD.saveDetalle(this.listDetalles).subscribe((res: any[]) => {
          this.loading = false;
          this.getTodo();
          this.limpiarRegresar();
          this.formulario.reset();
        }, (err) => {
          this.loading = false;
        });

      }, 1000);

    }).catch((err) => {
      // console.log(err);
    });

  }

  actualizar() {

    console.log("ACTUALIZAR")

    this.listSubDistribucion = [];
    let datos = this.formulario.getRawValue();
    console.log("datos", datos);

    if (this.isCreate) {
      datos.fechaInicio = datos.fechaInicioDDMMYYYY + "T00:00:00";
      datos.fechaFin = datos.fechaFinDDMMYYYY ? datos.fechaFinDDMMYYYY + "T00:00:00" : null;
      datos.fechaCarga = datos.fechaCargaDDMMYYYY.split('/').reverse().join('-') + "T00:00:00";
    } else {
      datos.fechaInicio = datos.fechaInicioDDMMYYYY + "T00:00:00";
      datos.fechaFin = datos.fechaFinDDMMYYYY ? datos.fechaFinDDMMYYYY + "T00:00:00" : null;
      datos.fechaCarga = datos.fechaCargaDDMMYYYY.split('/').reverse().join('-') + "T00:00:00";
    }

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: this.formulario.get('estado').value == "DESBALANCE" ? 'Asignación desbalanceada, está seguro de continuar?' : '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {


      console.log("ACTUALIZAR res", res)

      setTimeout(() => {
        console.log("this.listDetalles", this.listDetalles)

        for (let i = 0; i < this.listDetalles.length; i++) {
          this.listSubDistribucion = [];
          this.listDetalles[i].asignacionId = this.formulario.get('idAsignacion').value;
          if (this.listDetalles[i].subcategorias !== null && this.listDetalles[i].subcategorias !== undefined && this.listDetalles[i].subcategorias.length > 0) {
            for (let j = 0; j < this.listDetalles[i].subcategorias.length; j++) {
              this.listSubDistribucion.push(this.listDetalles[i].subcategorias[j]);
            }

            this._serviciosCRUD.saveSubCategorias(this.listSubDistribucion).subscribe((res: any[]) => {
              this.loading = false;
              this.listSubDistribucion = [];
            }, (err) => {
              this.loading = false;
              this.listSubDistribucion = [];
            });
          }
        }

        this._serviciosCRUD.saveDetalle(this.listDetalles).subscribe((res: any[]) => {
          this.loading = false;
          this.getTodo();
          this.limpiarRegresar();
          this.formulario.reset();
        }, (err) => {
          this.loading = false;
        });

        console.log("this._serviciosCRUD.saveSubCategorias", this.listSubDistribucion)

      }, 1000);

    }).catch((err) => {
      // console.log(err);
    });
  }

  getFormValidationErrors() {

    // console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    // console.log('Number of errors: ', totalErrors);
    // console.log('formulario: ', this.formulario.getRawValue());
    // console.log('formularioDetalle: ', this.formularioDetalle.getRawValue());
    // console.log('formularioCategorias: ', this.formularioCategorias.getRawValue());
  }

  // onChangeVendedor(event: any) {
  //   if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
  //   this.loading = true;
  //   if (this.formulario.get("vendedorId").value != null && this.formulario.get("vendedorId").value.length > 0) {
  //     this._serviciosCRUD.getVededor(this.formulario.get("vendedorId").value).subscribe(
  //       (resp) => {
  //         if (resp) {
  //           this.formulario.controls['nombreVendedorDescripcion'].setValue(resp.nombreVendedor1);
  //         } else {
  //           this.formulario.controls['nombreVendedorDescripcion'].setValue('');
  //         }
  //         this.loading = false;
  //       },
  //       (error) => {
  //         this.loading = false;
  //         this.formulario.controls['nombreVendedorDescripcion'].setValue('');
  //       }
  //     );
  //   }
  // }

  agregarDetalle() {

    let data = this.formularioDetalle.getRawValue();

    console.log("agregarDetalle")
    console.log("data", data)
    console.log("listDetalles", this.listDetalles)

    let variable = this.listDetalles.findIndex(e => e.variableId == data.variableId)

    if (variable >= 0) {
      this._utils.mensajeErroToast('No se pueden duplicar las variables');
      return;
    }

    if (this.totalPesos + parseFloat(data.valorPeso) > 100) {
      // console.log("this.totalPesos + parseFloat(data.valorPeso) > 100", this.totalPesos + parseFloat(data.valorPeso))
      this._utils.mensajeErroToast('El total de Peso Asignado no puede ser mayor a 100.');
      return;
    }

    let variableDescripcion = this.listTiposDeVariables.findIndex(e => e.idVariable == this.formularioDetalle.get('variableId').value);
    let tipoVendedorDescripcion = this.listTiposDeVendedores.findIndex(e => e.idTipo == this.formulario.get('tipoVendedorId').value);
    data.asignacionId = this.formulario.get("idAsignacion").value;
    data.variableDescripcion = this.listTiposDeVariables[variableDescripcion].descripcion;
    data.tipoVendedorDescripcion = this.listTiposDeVendedores[tipoVendedorDescripcion].descripcion;
    data.dolares = (this.listTiposDeVendedores[tipoVendedorDescripcion].sueldoVariable * (data.valorPeso / 100)).toFixed(2);
    data.variableDistribuida = this.listTiposDeVariables[variableDescripcion].tipoVariable == "DISTRIBUIDA" ? true : false;
    data.subcategorias = this.listSubDistribucion;

    this.listDetalles.push(data);
    this.totalPesosDolares();
    // console.log("variableDescripcion", this.formularioDetalle.get('variableId').value, this.listTiposDeVariables[variableDescripcion])
    // console.log("tipoVendedorDescripcion", this.formulario.get('tipoVendedorId').value, this.listTiposDeVendedores[tipoVendedorDescripcion])
    // console.log("listTiposDeVendedores", this.listTiposDeVendedores)
    // console.log("listTiposDeVariables", this.listTiposDeVariables)
    // console.log("agregarDetalle()", this.listDetalles)
    // console.log("agregarDetalle()", this.listTiposDeVendedores[tipoVendedorDescripcion].sueldoVariable + " * " + (data.valorPeso / 10))

    this.formularioDetalle.reset();
    this.listSubDistribucion = [];

    console.log("this.listDetalles", this.listDetalles)
  }

  agregarDistribucion() {
    this.listSubDistribucion = [];
    this.formularioCategorias.reset();
    this.isCreateSubDistribucion = true;
    document.getElementById('buttonAbrirModal').click();
  }

  eliminarDetalle(index) {
    this.listDetalles.splice(index, 1);
    this.totalPesosDolares();

    console.log("this.listDetalles", this.listDetalles)
  }

  eliminarsubCategoria(index) {
    this.listSubDistribucion.splice(index, 1);
    this.totalPorcentajeSubCategorias();

    console.log("this.listDetalles", this.listDetalles)
  }

  totalPesos = 0;
  totalDolares = 0;
  totalPesosDolares() {
    this.totalPesos = 0;
    this.totalDolares = 0;
    for (let i = 0; i < this.listDetalles.length; i++) {
      this.totalPesos += parseFloat(this.listDetalles[i].valorPeso);
      this.totalDolares += parseFloat(this.listDetalles[i].dolares);
    }

    if (this.totalPesos == 100) this.formulario.get('estado').setValue('CUADRADO');
    else this.formulario.get('estado').setValue('DESBALANCE');
  }

  totalPorcentaje;
  totalPorcentajeSubCategorias() {
    this.totalPorcentaje = 0;
    for (let i = 0; i < this.listSubDistribucion.length; i++) {
      this.totalPorcentaje += parseFloat(this.listSubDistribucion[i].valorPeso);
    }
  }

  agregarSubCategoria() {
    let data = this.formularioCategorias.getRawValue();

    if (this.totalPorcentaje > 100) {
      this._utils.mensajeErroToast('El total de Peso de las SubCategorias no puede ser mayor a 100.');
      return;
    }
    console.log("this.get('subCategoria').value", this.formularioCategorias.get('subCategoria').value)
    console.log("this.listSubCategorias", this.listSubCategorias)
    let subCategoriaDescripcion = this.listSubCategorias.findIndex(e => e.idSubCategoria == this.formularioCategorias.get('subCategoria').value);
    console.log("subCategoriaDescripcion", subCategoriaDescripcion)
    data.asignacionId = this.formulario.get("idAsignacion").value;
    data.variableId = this.formularioDetalle.get('variableId').value;
    data.codSubcategoria = this.formularioCategorias.get('subCategoria').value;
    data.nombreSubcategoria = this.listSubCategorias[subCategoriaDescripcion].descripcionSubCategoria;
    data.valorPeso = 1;
    //data.valorPeso = this.formularioCategorias.get('valorPeso').value;
    this.listSubDistribucion.push(data);
    this.totalPorcentajeSubCategorias();
    this.formularioCategorias.reset();
    // console.log("this.listSubDistribucion", this.listSubDistribucion)
  }

  verDistribucion(asignacionId, variableId, index) {
    // console.log("verDistribucion", asignacionId, variableId, index)
    // console.log("listDetalles", this.listDetalles)
    this.isCreateSubDistribucion = false;
    // if (this.isCreate) {
    this.listSubDistribucion = this.listDetalles[index].subcategorias;
    this.totalPorcentajeSubCategorias();
    document.getElementById('buttonAbrirModal').click();
    // } else {
    //   this._serviciosCRUD.getSubDistribuciones(asignacionId, variableId).subscribe((res: any[]) => {
    //     // console.log("verDistribucion()", res)
    //     this.loading = false;
    //     this.listSubDistribucion = res;
    //     this.totalPorcentajeSubCategorias();
    //     document.getElementById('buttonAbrirModal').click();
    //   }, (err) => {
    //     this.loading = false;
    //     this.listSubDistribucion = [];
    //   });
    // }
  }

  guardarSubCategorias() {
    // console.log("guardarSubCategorias", this.formulario.getRawValue());
    document.getElementById('cerrarModal').click();
  }

}
